module.exports = __webpack_public_path__ + "static/doradztwo_biznesowe4-01-bb5b4083400c93a8f0d38a18259e4ec2.png";